// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__3AzEr","logo":"styles_logo__1uBUr","rotation":"styles_rotation__2PfQP","spin":"styles_spin__-eMHd"};